var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"resize-bar"},on:{"mousedown":function($event){return _vm.startDrag()}}})}
var staticRenderFns = []

export { render, staticRenderFns }